export default __webpack_public_path__ + "static/char-sp01-anr-efa25fbd6f3c8ee277d7b5d9d6115add.gif";